export enum COMPROBANTE_LIQUIDACION_TYPES {
    CL_SET_VIEW = 'CL_SET_VIEW',
    CL_SET_FORM_CLIENTE = 'CL_SET_FORM_CLIENTE',
    CL_HANDLE_ERRORS_CLIENTE = 'CL_HANDLE_ERRORS_CLIENTE',
    CL_SET_FORM_PRODUCTO = 'CL_SET_FORM_PRODUCTO',
    CL_HANDLE_ERRORS_PRODUCTO = 'CL_HANDLE_ERRORS_PRODUCTO',
    CL_SET_PRODUCTOS = 'CL_SET_PRODUCTOS',
    CL_SET_PRODUCTO_EDIT = 'CL_SET_PRODUCTO_EDIT',
    CL_SET_PRODUCTO_INDEX = 'CL_SET_PRODUCTO_INDEX',

    CL_ACTIVE_MODAL_EDITAR_PRODUCTO = 'CL_ACTIVE_MODAL_EDITAR_PRODUCTO',
    CL_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'CL_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
    CL_ACTIVE_MODAL_QUITAR_TODO = 'CL_ACTIVE_MODAL_QUITAR_TODO',
    CL_ACTIVE_MODAL_EMITIR = 'CL_ACTIVE_MODAL_EMITIR',
    CL_ACTIVE_MODAL_EMITIDO = 'CL_ACTIVE_MODAL_EMITIDO',
    CL_ACTIVE_MODAL_MAS_OPCIONES = 'CL_ACTIVE_MODAL_MAS_OPCIONES',
    CL_ACTIVE_MODAL_ENVIAR_CORREO = 'CL_ACTIVE_MODAL_ENVIAR_CORREO',
    CL_ACTIVE_MODAL_IMPRIMIR = 'CL_ACTIVE_MODAL_IMPRIMIR',
    CL_ACTIVE_MODAL_ANULAR = 'CL_ACTIVE_MODAL_ANULAR',
    CL_ACTIVE_MODAL_ANULADO = 'CL_ACTIVE_MODAL_ANULADO',
    CL_ACTIVE_MODAL_BUSQUEDA_DOCUMENTO = 'CL_ACTIVE_MODAL_BUSQUEDA_DOCUMENTO',

    CL_SET_QR_CODE = 'CL_SET_QR_CODE',
    CL_SET_RESPONSE_EMITIR = 'CL_SET_RESPONSE_EMITIR',

    CL_SET_CALCULOS_PRODUCTO = 'CL_SET_CALCULOS_PRODUCTO',
    CL_SET_CALCULOS_GENERALES = 'CL_SET_CALCULOS_GENERALES',

    CL_RESTART_FORM_PRODUCTO = 'CL_RESTART_FORM_PRODUCTO',
    CL_RESTART_ALL = 'CL_RESTART_ALL',
    CL_SET_CLIENTE_ENCONTRADO = 'CL_SET_CLIENTE_ENCONTRADO',
    CL_ACTIVE_MODAL_CLIENTE_ENCONTRADO = 'CL_ACTIVE_MODAL_CLIENTE_ENCONTRADO',

    CL_ACTIVE_ASOCIAR_DOCUMENTOS = 'CL_ACTIVE_ASOCIAR_DOCUMENTOS',
    CL_SET_DOCUMENTOS_ENCONTRADOS = 'CL_SET_DOCUMENTOS_ENCONTRADOS',
    CL_SET_DOCUMENTOS_ASOCIADOS = 'CL_SET_DOCUMENTOS_ASOCIADOS',
    CL_SET_LOADER_DOCUMENTOS_ASOCIADOS = 'CL_SET_LOADER_DOCUMENTOS_ASOCIADOS',
    CL_ACTIVE_ADVERTENCIA_ASOCIAR_DOCUMENTOS = 'CL_ACTIVE_ADVERTENCIA_ASOCIAR_DOCUMENTOS',

    CL_SET_FORM_BUSQUEDA_DOCUMENTO = 'CL_SET_FORM_BUSQUEDA_DOCUMENTO',
    CL_HANDLE_ERRORS_BUSQUEDA_DOCUMENTO = 'CL_HANDLE_ERRORS_BUSQUEDA_DOCUMENTO',
    CL_HANDLE_ACTIVE_MOSTRAR_DETALLE = 'CL_HANDLE_ACTIVE_MOSTRAR_DETALLE',
    CL_SET_TABLE_PRODUCTOS = 'CL_SET_TABLE_PRODUCTOS',
    CL_SET_FORM_DOCUMENTO_FISICO = 'CL_SET_FORM_DOCUMENTO_FISICO',
    CL_HANDLE_ERRORS_DOCUMENTO_FISICO = 'CL_HANDLE_ERRORS_DOCUMENTO_FISICO',
    CL_ACTIVE_EDITAR_DOCUMENTO_FISICO = 'CL_ACTIVE_EDITAR_DOCUMENTO_FISICO',
    CL_ACTIVE_AGREGAR_DOCUMENTO_FISICO = 'CL_ACTIVE_AGREGAR_DOCUMENTO_FISICO',
    CL_SET_DOCUMENTO_FISICO_EDIT = 'CL_SET_DOCUMENTO_FISICO_EDIT',
}
